import { Component, Prop, h, Host, State, Element, Watch } from '@stencil/core';

const iconRequestCache = new Map();
const iconCache = new Map();

declare global {
  interface Window {
    LG?: any;
  }
}

@Component({
  tag: 'lg-icon',
  styleUrl: 'lg-icon.scss',
})
export class LgIcon {
  folder = window.LG?.icon_folder ?? '/images/icons/';

  @Element() el: HTMLElement;
  @Prop({ reflect: true, mutable: true }) name: string;
  @State() svg: string | null;

  componentWillLoad() {
    this.fetchIcon();
  }

  @Watch('name')
  nameChanged() {
    this.fetchIcon();
  }

  componentDidUpdate() {
    this.el.querySelector('svg').setAttribute('aria-label', this.name.replace(/-/g, ' '));
  }

  fetchIcon() {
    // Add static version to icon url to prevent caching in different releases
    const iconUrl = this.name.match(/^https?:\/\//) ? this.name : `${this.folder}${this.name}.svg?v=${Date.now()}`;
    if (iconCache.has(this.name)) {
      this.svg = iconCache.get(this.name);
      return;
    }

    if (iconRequestCache.has(this.name)) {
      iconRequestCache.get(this.name).then(async svg => {
        this.svg = svg;
      });
      return;
    }

    const request = fetch(iconUrl)
      .then(async (response: Response) => {
        const svg = await this.getIconFromResponse(response);
        return svg;
      })
      .catch(() => {
        console.error('Unable to load icon');
        return null;
      });
    iconRequestCache.set(this.name, request);

    request.then(svg => {
      this.svg = svg;
    });
  }

  private async getIconFromResponse(response: Response) {
    if (!response.ok) {
      console.error('Unable to load icon');
      return;
    }

    const svg = await response.text();
    iconCache.set(this.name, svg);
    return svg;
  }

  render() {
    return <Host innerHTML={this.svg}></Host>;
  }
}
